module.exports = __webpack_public_path__ + "fonts/Gordita Medium.8a8d94a.woff";